import { render, staticRenderFns } from "./editFullAmount.vue?vue&type=template&id=3565a5f8&scoped=true&"
import script from "./editFullAmount.vue?vue&type=script&lang=js&"
export * from "./editFullAmount.vue?vue&type=script&lang=js&"
import style0 from "./editFullAmount.vue?vue&type=style&index=0&id=3565a5f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3565a5f8",
  null
  
)

component.options.__file = "editFullAmount.vue"
export default component.exports